export const WEBHOOKS_PAGE_TEST_ID = 'developers_webhooks';
export const WEBHOOKS_TITLE_TEST_ID = 'developers_webhooks_title-label';

export const WEBHOOKS_HEADER_CREATE_TEST_ID = 'developers_webhooks_create-btn';

export const WEBHOOKS_LOADING_TEST_ID = 'developers_webhooks_content-loading';
export const WEBHOOKS_ERROR_TEST_ID = 'developers_webhooks_content-error';
export const WEBHOOKS_ERROR_COPY =
  'Something went wrong loading your webhooks. Please try again.';

export const TOGGLE_WEBHOOK_ERROR =
  'Something went wrong updating the webhook status. Please try again.';
export const EDIT_WEBHOOK_SUCCESS = 'Webhook updated';
export const EDIT_WEBHOOK_GENERIC_ERROR =
  'Something went wrong updating the webhook. Please try again.';
export const BULK_EDIT_GENERIC_ERROR =
  'Something went wrong updating the webhooks. Please try again.';

export const WEBHOOKS_EMPTY_TEST_ID = 'developers_webhooks_empty';
export const WEBHOOKS_EMPTY_CTA_TEST_ID =
  'developers_webhooks_empty_create-btn';

export const WEBHOOKS_COPY_BUTTON_TEST_ID =
  'copy-to-clipboard_button_value-btn';

export const WEBHOOKS_TABLE_TEST_ID = 'developers_webhooks_table';
export const WEBHOOKS_TOTAL_TEST_ID = 'developers_webhooks_total-label';
export const WEBHOOKS_ROW_TEST_ID = 'developers_webhooks_table-row';
export const WEBHOOKS_STATUS_BADGE_TEST_ID = (uuid: string) =>
  `developers_webhooks_table-status-${uuid}`;
export const WEBHOOKS_CHEVRON_TEST_ID = (uuid: string) =>
  `developers_webhooks_chevron-icon-${uuid}`;

export const WEBHOOKS_SELECT_ALL_TEST_ID =
  'developers_webhooks_select-all-checkbox';
export const WEBHOOKS_SELECT_ROW_TEST_ID = (uuid: string) =>
  `developers_webhooks_select-row-checkbox-${uuid}`;
export const WEBHOOKS_SELECTION_BAR_TEST_ID =
  'developers_webhooks_selection-bar';
export const WEBHOOKS_SELECTION_ACTIVATE_TEST_ID =
  'developers_webhooks_selection-bar_activate-all-btn';
export const WEBHOOKS_SELECTION_DEACTIVATE_TEST_ID =
  'developers_webhooks_selection-bar_deactivate-all-btn';
export const WEBHOOKS_SELECTION_BULK_EDIT_TEST_ID =
  'developers_webhooks_selection-bar_bulk-edit-btn';

export type ToggleMode = 'activate' | 'deactivate';

export const TOGGLE_WEBHOOK_STATUS_MODAL_TEST_ID =
  'developers_webhooks_toggle-status-modal';
export const TOGGLE_WEBHOOK_STATUS_CONFIRM_TEST_ID =
  'developers_webhooks_toggle-status_confirm-btn';
export const TOGGLE_WEBHOOK_STATUS_CANCEL_TEST_ID =
  'developers_webhooks_toggle-status_cancel-btn';
export const TOGGLE_WEBHOOK_STATUS_BLOCKED_ROW_TEST_ID = (uuid: string) =>
  `developers_webhooks_toggle-status_blocked-row-${uuid}`;

export const REACTIVATE_WEBHOOK_CONFLICT_MODAL_TEST_ID =
  'developers_webhooks_reactivate-conflict-modal';
export const REACTIVATE_WEBHOOK_CONFLICT_CONFIRM_TEST_ID =
  'developers_webhooks_reactivate-conflict_confirm-btn';
export const REACTIVATE_WEBHOOK_CONFLICT_DISMISS_TEST_ID =
  'developers_webhooks_reactivate-conflict_dismiss-btn';

export const REACTIVATE_WEBHOOK_CONFLICT_BODY_INTRO =
  'An inactive webhook already exists for the following events:';
export const REACTIVATE_WEBHOOK_CONFLICT_BODY_OUTRO =
  'Reactivate to resume event deliveries to the existing endpoints.';

export const REACTIVATE_WEBHOOK_ERROR =
  'Something went wrong reactivating the webhook. Please try again.';

export const BULK_EDIT_WEBHOOKS_FORM_ID = 'bulk-edit-webhooks-form';

export const BULK_EDIT_WEBHOOKS_MODAL_TEST_ID =
  'developers_webhooks_bulk-edit-modal';
export const BULK_EDIT_WEBHOOKS_INFO_TEST_ID =
  'developers_webhooks_bulk-edit_info-label';
export const BULK_EDIT_WEBHOOKS_ENDPOINT_TEST_ID =
  'developers_webhooks_bulk-edit_endpoint-input';
export const BULK_EDIT_WEBHOOKS_ENDPOINT_ERROR_TEST_ID =
  'developers_webhooks_bulk-edit_endpoint-error';
export const BULK_EDIT_WEBHOOKS_BUSINESS_UNIT_TEST_ID =
  'developers_webhooks_bulk-edit_business-unit-select';
export const BULK_EDIT_WEBHOOKS_BUSINESS_UNIT_OPTION_TEST_ID = (uuid: string) =>
  `developers_webhooks_bulk-edit_business-unit-option-${uuid}`;
export const BULK_EDIT_WEBHOOKS_X_AUTH_TEST_ID =
  'developers_webhooks_bulk-edit_x-auth-uuid-select';
export const BULK_EDIT_WEBHOOKS_X_AUTH_OPTION_TEST_ID = (uuid: string) =>
  `developers_webhooks_bulk-edit_x-auth-uuid-option-${uuid}`;
export const BULK_EDIT_WEBHOOKS_SAVE_TEST_ID =
  'developers_webhooks_bulk-edit_save-btn';
export const BULK_EDIT_WEBHOOKS_CANCEL_TEST_ID =
  'developers_webhooks_bulk-edit_cancel-btn';

export const BULK_EDIT_WEBHOOKS_TITLE = 'Edit webhooks';
